import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { Router } from "@angular/router";
import { ModalService } from "../../services/shared/modal.service";
import { ApplicationError } from "./applicationerror";

@Injectable()
export class CustomErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {
  }

  public handleError(error: any) {
    console.error(error);
    if (error.handled) {
      console.error(error);
      return;
    }

    const modalService = this.injector.get(ModalService);
    const router = this.injector.get(Router);

    if (error instanceof ApplicationError)
      modalService.showModal(error.message ? error.message : error.toString());

    //enable this for prod
    //if (!error.status) { console.log('!!!ERROR OCCURED!!:' + error); return; }

    switch (error.status) {
      case 400:
        {
          modalService.showModal(error.error);
          break;
        }
      case 401:
        {
          router.navigate(["/login"]);
          break;
        }
    }
  }
}
